import Dashboard from 'views/Dashboard/Dashboard';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import Login from 'views/Login/Login';
import MinhasRequisicoes from 'views/MinhasRequisicoes/MinhasRequisicoes';
import BIM from 'views/BIM/BIM';

const dashboardRoutes = [
  {
    path: '/minhasrequisicoes',
    name: 'Minhas Requisições',
    component: MinhasRequisicoes,
    icon: ListAltIcon,
    layout: '/admin',
  },
  {
    path: '/bim',
    name: 'BIM',
    component: BIM,
    icon: ShoppingBasketIcon,
    layout: '/admin',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    layout: '/auth',
  },
];

export default dashboardRoutes;
